import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHero, Loading, Empty, StatusBadge, TypeTag, fmtMoney } from "@/components/common";

const FISCAL_IMG = "https://images.pexels.com/photos/8382242/pexels-photo-8382242.jpeg";

export default function Investigations() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/investigations").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="investigations-page">
      <PageHero label="Fiscalización" title="Investigaciones documentadas" image={FISCAL_IMG}
        subtitle="Evidencia antes que acusaciones. Cada expediente incluye cronología, fuentes primarias, dinero relacionado y estado editorial." />
      <div className="max-w-6xl mx-auto px-6 py-12">
        {items === null ? <Loading /> : items.length === 0 ? <Empty /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map((iv) => (
              <Link key={iv.id} to={`/fiscalizacion/${iv.id}`} data-testid={`investigation-card-${iv.id}`}
                className="block bg-white rounded-lg border border-slate-200 p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-200">
                <div className="flex items-center gap-2 mb-3">
                  <TypeTag type={iv.content_type} />
                  <StatusBadge status={iv.investigation_status} />
                </div>
                <h3 className="font-heading font-bold text-xl text-slate-900 mb-2">{iv.title}</h3>
                <p className="text-slate-600 text-sm line-clamp-3">{iv.summary}</p>
                <div className="flex items-center justify-between mt-4">
                  {iv.amount != null ? <span className="text-sm font-semibold text-rose-500">{fmtMoney(iv.amount)}</span> : <span />}
                  <span className="text-sm font-semibold text-cyan-600">Leer expediente →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
